import React from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

import { EpiContext } from '../Shared/Scripts/Store/EpiContext/Types';
import { FeilmeldingComponent } from '../Shared/Scripts/Components/FeilmeldingComponent';
import Valg from '../Shared/Scripts/Models/Valg';

import VeilederInntektskalkulatorDto from './Models/VeilederInntektskalkulatorDto';
import { VeilederInntektskalkulatorAppState } from './Store';
import * as Ids from './Models/Ids';
import * as ValgTypes from './Store/Valg/Types';
import { updateValg, updateVisning } from './Store/Valg/Actions';
import { ResultatValg } from './Store/Resultat/Types';
import BoksA from './Components/BoksA';
import BoksB from './Components/BoksB';
import { Satser } from './Utilities/SatserApi';

interface AppOwnProps {}

type AppProps = AppOwnProps & MapStateToProps & MapDispatchToProps;

ReactModal.setAppElement(document.getElementById(Ids.AppContainerId) as HTMLElement);

interface AppState {
    collapsed: boolean
}

export class App extends React.Component<AppProps, AppState> {
    constructor(props: AppProps) {
        super(props);
        this.state = {collapsed: true}
    }

    render(): JSX.Element {
        const { valg, resultat, dispatchUpdateValg, epiContext, satser } = this.props;
        const { epiModel, locale, valuta } = this.props.epiContext;

        if (epiContext.epiModelFeilet) {
            return <FeilmeldingComponent />;
        }

        function hentBreddeKlasse(): string {
            if(epiModel?.bredde === undefined || epiModel.bredde.value === "") {
                return "c-veileder c-veileder--mini";
            }
            return "c-veileder " + epiModel.bredde.value;
        }

        // function registerSiteImproveEvents(): void {
        //     if(!SiteImproveState.Startet) {
                //if(valg.visHeleKalkulator) {
                    //veileder påstartet
                    //SiteImproveState.Startet = true;
                    //SiteImproveHandler.registerSiteImproveEvent(SiteImproveKategorier.Veileder, SiteImproveEvents.Klikk, "Vis betalingskalkulator");
                //}
            // }
        // }

        if (epiModel != null) {
            return (
                <div className={" c-veileder c-veileder--mini " + hentBreddeKlasse()}>
                    {/* {registerSiteImproveEvents()} */}
                    <BoksA
                        valg = {valg}
                        locale = {locale}
                        valuta = {valuta}
                        onInputChange={(nyttValg: Valg<string>): void => {
                            dispatchUpdateValg({ inntekt: nyttValg });
                        }}
                    />
                    {valg.inntekt !== null && valg.inntekt !== undefined &&
                        <BoksB 
                            valg = {valg}
                            locale = {locale}
                            valuta = {valuta}
                            resultat = {resultat}
                            satser = {satser}
                        />
                    }
                </div>
            );
        } else {
            return <div>Laster...</div>;
        }
    }
}

interface MapStateToProps {
    valg: ValgTypes.ValgState;
    epiContext: EpiContext<VeilederInntektskalkulatorDto>;
    resultat: ResultatValg;
    satser: Satser | null;
}

interface MapDispatchToProps {
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>) => void;
}

const mapDispatchToProps = (dispatch: ThunkDispatch<VeilederInntektskalkulatorAppState, {}, AnyAction>): MapDispatchToProps => ({
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>): void => {
        dispatch(updateValg(newValg));
        dispatch(updateVisning());
    },
});

const mapStateToProps = (state: VeilederInntektskalkulatorAppState): MapStateToProps => ({
    valg: state.valg,
    epiContext: state.epiContext,
    resultat: state.resultat,
    satser: state.satser,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
